import { useEffect } from 'react';

import type { SetQueryResult } from './DataResolver';
import type { PlannedQuery, TopCompaniesOf } from './plan-data-queries';
import type { QueryResult } from './resolve-items';
import { useCompositionV4Tables } from './use-composition-v4-tables';
import { useTopCompaniesTables } from './use-top-companies';

const useServeQueryResult = (
  key: string,
  result: QueryResult | null,
  setQueryResult: SetQueryResult
) => {
  useEffect(() => {
    setQueryResult(key, result);
  }, [setQueryResult, key, result]);

  // A query the plan stops running leaves nothing behind to be served later.
  useEffect(() => () => setQueryResult(key, undefined), [setQueryResult, key]);
};

export const CompositionV4QueryRunner = ({
  query: { key, primaryDimension, tables },
  setQueryResult,
}: {
  query: PlannedQuery;
  setQueryResult: SetQueryResult;
}) => {
  const result = useCompositionV4Tables({ primaryDimension, tables });
  useServeQueryResult(key, result, setQueryResult);
  return null;
};

export const TopCompaniesQueryRunner = ({
  query: { key, tables },
  topCompaniesOf,
  setQueryResult,
}: {
  query: PlannedQuery;
  topCompaniesOf: TopCompaniesOf;
  setQueryResult: SetQueryResult;
}) => {
  const result = useTopCompaniesTables({ tables, topCompaniesOf });
  useServeQueryResult(key, result, setQueryResult);
  return null;
};
